import React from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faPlay } from '@fortawesome/free-solid-svg-icons'

const Button = ({title, className}) => {
    return (
        <button aria-label="Default button" className={`btn btn-success ${className}`}>
            {title}
            <div className="icon">
                <FontAwesomeIcon icon={faPlay} />
            </div>
        </button>
    )
}

export default Button